export default __webpack_public_path__ + "static/media/frieden_film_image.2d11ead5.png";